import { render, staticRenderFns } from "./uninjuryDept.vue?vue&type=template&id=7c88b4e8&scoped=true"
import script from "./uninjuryDept.vue?vue&type=script&lang=js"
export * from "./uninjuryDept.vue?vue&type=script&lang=js"
import style0 from "./uninjuryDept.vue?vue&type=style&index=0&id=7c88b4e8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c88b4e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c88b4e8')) {
      api.createRecord('7c88b4e8', component.options)
    } else {
      api.reload('7c88b4e8', component.options)
    }
    module.hot.accept("./uninjuryDept.vue?vue&type=template&id=7c88b4e8&scoped=true", function () {
      api.rerender('7c88b4e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/noaccident/uninjuryDept.vue"
export default component.exports